document.documentElement.classList.remove('no-js');
document.addEventListener('click', async (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) {
      nav.hidden = !nav.hidden;
      toggle.setAttribute('aria-expanded', String(!nav.hidden));
    }
  }
  const qty = event.target.closest('[data-qty]');
  if (qty) {
    const input = qty.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(qty.dataset.qty));
  }
});
